import '@fancyapps/fancybox';
import 'slick-carousel';

import $ from 'jquery';

class Post_listing {
	constructor($el) {
		// module vars declarations
		this.$el = $el;
		this.$slider = this.$el.find('.post_listing__articles');
		this.isSearchOrArchive = $(document.body).hasClass('search') || $(document.body).hasClass('archive');
		// methods initialization
		this.init();
	}

	init() {
		// slider
		this.slider();
		this.sliderInitialization();

		const that = this;
		$(window).on("resize", function () {
		  that.sliderInitialization();
		});
	}

	isSliderInitialized() {
		return this.$slider.hasClass("slick-initialized");
	  }
	
	sliderInitialization() {
		if (typeof this.$slider === "undefined") {
			return;
		}
		
		if (window.innerWidth < $phpVars.breakpoint["screen-lg"]) {
			if (!this.isSliderInitialized()) {
			this.slider();
			}
		}
	}

	slider() {
		if(this.isSearchOrArchive) {
			return;
		}
		
		if (typeof this.$slider === "undefined") {
			return;
		}

		if (this.$slider.find('> div').length <= 1) {
			return;
		}

		this.$slider.slick({
			adaptiveHeight: false,
			fade: true,
			speed: 500,
			arrows: false,
			dots: true,
			infinite: true,
			mobileFirst: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnHover: false,
			pauseOnFocus: false,
			swipe: true,
			responsive: [{
				breakpoint: 992,
				settings: "unslick"
			}]
		});
	}
}

export default Post_listing;